import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-start" }, "Perfil", -1)
const _hoisted_2 = { class: "grid grid-cols-1 md:grid-cols-12 my-0 gap-0" }
const _hoisted_3 = { class: "md:flex md:flex-col hidden col-span-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Especialidade", -1)
const _hoisted_5 = { class: "grid grid-cols-12 gap-4 my-6" }
const _hoisted_6 = { class: "col-span-12 md:col-span-5" }
const _hoisted_7 = { class: "col-span-4 md:col-span-2" }
const _hoisted_8 = { class: "col-span-8 md:col-span-5" }
const _hoisted_9 = { class: "col-span-12 md:col-span-10" }
const _hoisted_10 = { class: "col-span-12 md:col-span-2" }
const _hoisted_11 = { class: "text-start" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Documentos", -1)
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  key: 1,
  class: "flex gap-4 flex-wrap"
}
const _hoisted_15 = { class: "ml-auto w-full sm:max-w-[140px]" }
const _hoisted_16 = { class: "flex justify-center" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", { class: "text-base font-normal" }, [
  /*#__PURE__*/_createTextVNode("O perfil foi desvinculado"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("com sucesso!")
], -1)

import { ref, toRefs, reactive } from 'vue'
import ModalVue from '@/components/designSystem/modals/Modal.vue'
import SuccessIcon from '@/assets/icons/success.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import Input from '@/components/designSystem/Inputs/Input.vue'
import { UserInfo } from '.'


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileModal',
  props: {
    modalStateProp: { type: Boolean },
    doctor: {}
  },
  emits: ['close'],
  setup(__props: any, { emit }) {

const props = __props;



const address = reactive({
  cep: props.doctor.address.cep,
  uf: props.doctor.address.uf,
  city: props.doctor.address.city,
  street: props.doctor.address.street,
  number: props.doctor.address.number
})



const { modalStateProp } = toRefs(props)

const showModalDeleteSuccess = ref(false)

const close = () => {
  emit('close')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ModalVue, {
      onClose: close,
      modalActive: _unref(modalStateProp)
    }, {
      header: _withCtx(() => [
        _hoisted_1
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_15, [
          _createVNode(FilledButton, {
            onClick: _cache[5] || (_cache[5] = () => (showModalDeleteSuccess.value = true)),
            text: "Desvincular",
            width: "100%"
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(UserInfo), {
            doctor: props.doctor
          }, null, 8, ["doctor"]),
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("p", null, _toDisplayString(_ctx.doctor.specialty), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(Input, {
              disabled: "",
              modelValue: address.cep,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((address.cep) = $event)),
              value: address.cep,
              width: "100%",
              label: "CEP*"
            }, null, 8, ["modelValue", "value"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(Input, {
              disabled: "",
              modelValue: address.uf,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((address.uf) = $event)),
              value: address.uf,
              width: "100%",
              label: "UF*"
            }, null, 8, ["modelValue", "value"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(Input, {
              disabled: "",
              modelValue: address.city,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((address.city) = $event)),
              value: address.city,
              width: "100%",
              label: "Cidade*"
            }, null, 8, ["modelValue", "value"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(Input, {
              disabled: "",
              modelValue: address.street,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((address.street) = $event)),
              value: address.street,
              width: "100%",
              label: "Rua*"
            }, null, 8, ["modelValue", "value"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(Input, {
              disabled: "",
              modelValue: address.number,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((address.number) = $event)),
              value: address.number,
              width: "100%",
              label: "Número*"
            }, null, 8, ["modelValue", "value"])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          (_ctx.doctor.documents.length <= 0)
            ? (_openBlock(), _createElementBlock("p", _hoisted_13, "Este profissional não possui documentos cadastrados"))
            : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.doctor.documents, (document) => {
                  return (_openBlock(), _createElementBlock("p", { key: document }, _toDisplayString(document), 1))
                }), 128))
              ]))
        ])
      ]),
      _: 1
    }, 8, ["modalActive"]),
    _createVNode(ModalVue, {
      onClose: _cache[6] || (_cache[6] = 
      () => {
        showModalDeleteSuccess.value = false
        close()
      }
    ),
      modalActive: showModalDeleteSuccess.value
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_16, [
          _createVNode(SuccessIcon)
        ])
      ]),
      default: _withCtx(() => [
        _hoisted_17
      ]),
      _: 1
    }, 8, ["modalActive"])
  ], 64))
}
}

})